export function deepCopy<T>(value: T): T {
    let stringified = JSON.stringify(value);

    return JSON.parse(stringified);
}
